import { render, staticRenderFns } from "./QuantidadeStepper.vue?vue&type=template&id=507af0fa&scoped=true&"
import script from "./QuantidadeStepper.vue?vue&type=script&lang=js&"
export * from "./QuantidadeStepper.vue?vue&type=script&lang=js&"
import style0 from "./QuantidadeStepper.vue?vue&type=style&index=0&id=507af0fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507af0fa",
  null
  
)

export default component.exports